export const bidAmountFieldName = 'amount';
export const bidTypeFieldName = 'bidType';
export const jurisdictionsSelectionTypeFieldName = 'jurisdictionsSelectionType';
export const applicableJurisdictionsFieldName = 'applicableJurisdictions';
export const noteFieldName = 'note';
